<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>z Detayları Ekranı</h1>
        </div>

        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">Duyuru Detayları</a></li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title" style="text-align:center">
              Duyuru Detayları
            </h3>
            <div class="tile-body">
              <form>
                <div class="form-group">
                  <label class="control-label">Başlık:</label>
                  <label class="form-control">{{ result.title }}</label>
                </div>
                <div class="form-group">
                  <label class="control-label">İçerik:</label>
                  <p class="form-control">{{ result.content }}</p>
                </div>
                <div class="form-group">
                  <label class="control-label">Yayın Tarihi:</label>
                  <label class="form-control">{{ result.reg_date }}</label>
                </div>
              </form>
            </div>
            <br>
            <button
              v-if="admin_token"
              type="button"
              @click="deleteNotice()"
              class="btn btn-outline-danger"
            >
              Duyuruyu Sil
            </button>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      result: [],
      admin_token: "",
      id: this.$route.query.id,
    };
  },
  mounted: function() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    this.admin_token = localStorage.getItem("admin_token");
    if (!this.admin_token) {
      if (!token) {
        this.$router.push("/");
      }
    }
    var datas = {
      noticeId: this.id,
    };

    let dataUrl = store.state.base_url + "User/getByIdNotice.php?key=123";
    return axios.post(dataUrl, JSON.stringify(datas)).then((response) => {
      this.result = response.data;
    });
  },
  methods:{
    deleteNotice: function() {
      var url = store.state.base_url + "Admin/deleteNotice.php?key=123";
      var datas = {
        id: localStorage.getItem("id"),
        admin_token: localStorage.getItem("admin_token"),
        noticeId: this.id,
      };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data == true) {
            this.$swal({
              text: "Duyuru Başarıyla Silindi!",
              icon: "success",
              closeOnClickOutside: true,
            });
           // setTimeout(function() {location.reload()},1250);
           this.$router.push("adminNotices");
          }

          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
  },
  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/NoticesDetail.vue